export default "__VITE_ASSET__12025beb__"